import { isEqual, isEmpty } from 'lodash';
import { Schedule } from './schedule';
export class EditSchedule extends Schedule {
    #changes;
    constructor(model) {
        super(model);
        this.#changes = new Map();
    }
    get name() {
        return this.getValue('name');
    }
    set name(value) {
        value === super.name ?
            this.#changes.delete('name') :
            this.#changes.set('name', value);
    }
    get enabled() {
        return this.getValue('enabled');
    }
    set enabled(value) {
        value === super.enabled ?
            this.#changes.delete('enabled') :
            this.#changes.set('enabled', value);
    }
    get timezone() {
        return this.getValue('timezone');
    }
    set timezone(value) {
        value === super.timezone ?
            this.#changes.delete('timezone') :
            this.#changes.set('timezone', value);
    }
    get version() {
        return this.getValue('version');
    }
    set version(value) {
        value === super.version ?
            this.#changes.delete('version') :
            this.#changes.set('version', value);
    }
    get data() {
        return this.getValue('data');
    }
    set data(value) {
        const currentData = super.data;
        if (!isEqual(currentData.ics, value.ics) ||
            !isEqual(currentData.schedule, value.schedule)) {
            this.#changes.set('data', value);
        }
        else {
            this.#changes.delete('data');
        }
    }
    getValue(prop) {
        return this.#changes.has(prop) ? this.#changes.get(prop) : super[prop];
    }
    reset() {
        this.#changes.clear();
    }
    hasChanges() {
        return this.#changes.size;
    }
    changes() {
        const changes = Object.fromEntries(this.#changes);
        if (this.isNew()) {
            Object.keys(this.getModel()).forEach((key) => {
                changes[key] = this.getValue(key);
            });
        }
        // if we are making any kinds of changes, always send the version so the API knows how to validate
        if (!isEmpty(changes)) {
            changes.version = this.getValue('version');
        }
        return changes;
    }
}
